import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import { encode } from "base64-arraybuffer";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ComprasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_EMBARQUES = process.env.REACT_APP_URL_EMBARQUES;
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_COMPRAS_ACUMULADOS = process.env.REACT_APP_URL_COMPRAS_ACUMULADOS;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [mailTo, setMailTo] = useState("danysalame18@gmail.com");

  const [embarques, setEmbarques] = useState([]);
  const [selectedEmbarque, setSelectedEmbarque] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_general, setTotalGeneral] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(19);
  const [tipo, setTipo] = useState("");
  const [articulosEmb, setArticulosEmb] = useState([]);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idArticulosEmabrque: "",
      articulos: "",
      articulosName: "",
      cantidad: 0,
      piezasPorCaja: 0,
      cajas: 0,
      precio: 0,
      precioMX: 0,
      tipoCambio: 0,
      total:0,
      lote: "NA",
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_EMBARQUES}PendientesRecibir`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allEmbarques = res.data;
        setEmbarques(allEmbarques);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

const saveCompraNueva = async (event) => {
  event.preventDefault();

  // El stock vive en las variantes: un renglon en master dejaria la mercancia en el master
  const enMaster = articulosEmb.filter((a) => a.articulos[0] && a.articulos[0].modelo === "MASTER");
  if (enMaster.length) {
    Swal.fire({
      icon: "error",
      title: "Hay renglones en master",
      html: `Esta OC trae ${enMaster.length} renglón(es) en un master y el inventario vive en las variantes. Cambia la OC a la variante que se compra antes de recibir:<br/><br/>${enMaster
        .slice(0, 15)
        .map((a) => a.articulos[0].SKU)
        .join("<br/>")}${enMaster.length > 15 ? "<br/>..." : ""}`,
    });
    return;
  }

  if (fecha !== "" && observaciones !== "") {
    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos =
      inputFields.length + inputFields.length + inputFields.length;

    // ✅ si es Nacional, sumamos 2 procesos más por cada artículo:
    // 1) actualizar costoMX en articulos
    // 2) actualizar costoUnitario en inventarios
    if (tipo === "Nacional") {
      totalArticulos = totalArticulos + inputFields.length + inputFields.length;
    }

    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    };

    const terminaProceso = () => {
      totalArticulos = totalArticulos - 1;

      if (totalArticulos === 0) {
        axios
          .post(
            URL_LOGS,
            {
              tipo: "Crear Compra",
              detalle: `EMBARQUES ${selectedEmbarque}`,
              user: user.id,
            },
            { headers }
          )
          .then(() => {
            Swal.fire("Good job!", "Creado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error?.response?.data || error.message}`,
            });
            console.log(error);
            setValidaBoton(true);
          });
      }
    };

    try {
      await axios
        .post(
          URL_COMPRAS,
          {
            fecha,
            embarques: selectedEmbarque,
            observaciones,
            total_cantidad,
            user: user.id,
            areas: selectedArea,
            tipoCambio,
          },
          { headers }
        )
        .then((data) => {
          // =========================
          // 1) PATCH INVENTARIOS COMPRA
          // =========================
          inputFields.map((a) => {
            if (a.articulos !== "") {
              axios
                .patch(
                  `${URL_INVENTARIOS}Compra`,
                  {
                    articulos: a.articulos,
                    cantidad: parseFloat(a.cantidad),
                    areas: selectedArea,
                    embarques: selectedEmbarque,
                    precioMX:
                      tipo === "Nacional"
                        ? parseFloat(a.precio)
                        : parseFloat(a.precio) * parseFloat(tipoCambio),
                    lote: "NA", // ya no hay lotes
                  },
                  { headers }
                )
                .then(() => {
                  terminaProceso();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Error al actualizar inventario de compra",
                    footer: `${error?.response?.data || error.message}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            } else {
              terminaProceso();
            }
          });

          // =========================
          // 2) PATCH ARTICULOS EMBARQUES
          // =========================
          inputFields.map((w) => {
            axios
              .patch(
                `${URL_ARTICULOS_EMBARQUES}EditEmbarcado/${w.idArticulosEmabrque}`,
                {
                  cantidad: w.cantidad,
                },
                { headers }
              )
              .then(() => {
                terminaProceso();
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error al actualizar artículos embarcados",
                  footer: `${error?.response?.data || error.message}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          // =========================
          // 3) POST COMPRAS ACUMULADOS
          // =========================
          inputFields.map((w) => {
            axios
              .post(
                `${URL_COMPRAS_ACUMULADOS}`,
                {
                  fecha,
                  cantidad: parseFloat(w.cantidad),
                  embarques: selectedEmbarque,
                  compras: data.data._id,
                  articulosEmbarques: w.idArticulosEmabrque,
                  articulos: w.articulos,
                  areas: selectedArea,
                  precio: w.precio,
                  tipoCambio,
                  precioMX:
                    tipo === "Nacional"
                      ? parseFloat(w.precio)
                      : parseFloat(w.precio) * parseFloat(tipoCambio),
                },
                { headers }
              )
              .then(() => {
                terminaProceso();
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error al guardar compra acumulada",
                  footer: `${error?.response?.data || error.message}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          });

          // =========================
          // 4) SI ES NACIONAL:
          //    PATCH A ARTICULOS -> costoMX = precio
          // =========================
          if (tipo === "Nacional") {
            inputFields.map((a) => {
              axios
                .patch(
                  `${URL_ARTICULOS}/${a.articulos}`,
                  {
                    costoMX: parseFloat(a.precio),
                  },
                  { headers }
                )
                .then(() => {
                  terminaProceso();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Error al actualizar costoMX del artículo",
                    footer: `${error?.response?.data || error.message}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });

            // =========================
            // 5) SI ES NACIONAL:
            //    PATCH A INVENTARIOS DEL MISMO ARTICULO
            //    costoUnitario = precio
            // =========================
            inputFields.map((a) => {
              axios
                .patch(
                  `${URL_INVENTARIOS}CostoUnitarioArticulo/${a.articulos}`,
                  {
                    costoUnitario: parseFloat(a.precio),
                  },
                  { headers }
                )
                .then(() => {
                  terminaProceso();
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Error al actualizar costoUnitario en inventarios",
                    footer: `${error?.response?.data || error.message}`,
                  });
                  console.log(error);
                  setValidaBoton(true);
                });
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error?.response?.data || error.message}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error?.response?.data || error.message}`,
      });
      console.log(error);
      setValidaBoton(true);
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `Faltan Datos`,
    });
  }
};

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.cajas = parseFloat(event.target.value) / i.piezasPorCaja;
        let totalParcial = parseFloat(event.target.value) * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  // const handleChangeInputCaja = (id, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i[event.target.name] = parseFloat(event.target.value);
  //       i.cantidad =
  //         parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);
  //   ActualizaTotales();
  // };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);

    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }
console.log("hola", inputFields)
  function jalaEmbarque(e) {
    setSelectedEmbarque(e);
    // 🔹 Buscar el embarque seleccionado
  const embarqueSeleccionado = embarques.find(ei => ei._id === e);

  // 🔹 Asignar tipo desde embarque
  if (embarqueSeleccionado) {
    setTipo(embarqueSeleccionado.tipo); // 👈 aquí el cambio importante
  }

    axios
      .get(`${URL_ARTICULOS_EMBARQUES}/embarque/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosEmb = res.data;
        const arrayArt = allArticulosEmb.map((a) => {
          return {
            id: uuidv4(),
            idArticulosEmabrque: a._id,
            articulos: a.articulos[0]._id,
            articulosName: a.articulos[0].SKU + "  " + a.articulos[0].nombre ,
            cantidad: a.cantidad,
            piezasPorCaja: a.articulos[0].piezasPorCaja,
            cajas:
              parseFloat(a.cantidad) / parseFloat(a.articulos[0].piezasPorCaja),
            precio: a.costoUSD,
            total: a.cantidad * a.costoUSD,
            lote: "NA"
          };
        });
        setArticulosEmb(allArticulosEmb);
        setInputFields(arrayArt);

        let cant = arrayArt.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);

        let importes = arrayArt.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card container col-10">
          <h3 align="center">Nueva Entrada</h3>
          <Form onSubmit={saveCompraNueva}>
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Embarques / OC</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedEmbarque}
                  required
                  onChange={(e) => jalaEmbarque(e.target.value)}
                >
                  <option value="0">Selecciona un Embarque</option>
                  {embarques
                    .sort((a, b) => (a.idEmbarques < b.idEmbarques ? 1 : -1))
                    .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.idEmbarques}
                            {" / "} {a.contenedor}
                          </option>
                        );
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Almacen</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedArea}
                  required
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un almacen</option>
                  {areas
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      // if (a._id == AREAS_MATRIZ || a._id == AREAS_BODEGA) {
                        return <option value={a._id}>{a.name}</option>;
                      // }
                    })}
                </Input>
              </Col>
              <Col md={2}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Tipo Cambio
                </Label>
                <Input
                  type="number"
                  placeholder="TipoCambio"
                  value={tipoCambio}
                  required
                  onChange={(e) => {
                    setTipoCambio(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)} pzas.
                   {/* /{" "}
                  {"$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general)} */}
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}
<br />
            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">SKU</Label>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Articulo</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">Cajas</Label>
              </Col> */}
              <Col md={1}>
                <Label className="mr-sm-2">Pzas por Caja</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              {/* <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col> */}
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={2}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulosEmabrque}
                      required
                      disabled
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosEmb
                        .sort((a, b) =>
                          a.articulos[0].SKU > b.articulos[0].SKU ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.articulos[0].SKU}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="articulos"
                      type="select"
                      value={inputField.idArticulosEmabrque}
                      required
                      disabled
                    >
                      <option value="">Selecciona un Articulo</option>
                      {articulosEmb
                        .sort((a, b) =>
                          a.articulos[0].SKU > b.articulos[0].SKU ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.articulos[0].SKU} {a.articulos[0].nombre}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>


                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cajas"
                      type="number"
                      min="0"
                      step="any"
                      value={inputField.cajas.toFixed(2)}
                      onChange={(event) =>
                        handleChangeInputCaja(inputField.id, event)
                      }
                    />
                  </Col> */}

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="piezasPorCaja"
                      type="string"
                      value={inputField.piezasPorCaja}
                      disabled
                    />
                  </Col>

                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="cantidad"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Cantidad"
                      value={inputField.cantidad}
                      // onChange={(event) =>
                      //   handleChangeInputCantidad(inputField.id, event)
                      // }
                      disabled
                    />
                  </Col>
                  <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="precio"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Precio"
                      value={inputField.precio}
                      disabled
                    />
                  </Col>

                  {/* <Col md={1}>
                    <Input
                      bsSize="sm"
                      name="total"
                      type="number"
                      min="0"
                      step="any"
                      placeholder="Total"
                      value={inputField.total}
                      disabled
                    />
                  </Col> */}
                </Row>
              </div>
            ))}
            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES{" "}
                  {new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_cantidad)} pzas. 
                  {/* /{" "}
                  {"$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total_general)} */}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoCompras"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComprasCreate;
